import { motion } from 'framer-motion';
import GlassCard from '../ui/GlassCard';
import { FiTrendingUp, FiTarget, FiMessageSquare, FiCalendar, FiZap, FiUsers } from 'react-icons/fi';

const MOCK_LEADERBOARD = [
  { rank: 1, name: 'Kaptan Yılmaz', xp: '12,450 XP', avatar: '🥇' },
  { rank: 2, name: 'Zehra T.', xp: '11,200 XP', avatar: '🥈' },
  { rank: 3, name: 'Burak A.', xp: '9,870 XP', avatar: '🥉' },
  { rank: '?', name: 'Sen', xp: 'Şimdi başla!', avatar: '🎯', isYou: true },
];

const FEATURES_RIGHT = [
  { 
    icon: <FiCalendar size={22} />, title: 'Streak Sistemi',
    desc: 'Her gün sisteme girip çalışarak serinizi uzatın. Ateş rozetleri kazanın ve düşmeyin!',
    color: 'var(--color-warning)',
    visual: (
      <div style={{ display: 'flex', gap: '6px', marginTop: '16px' }}>
        {[1,2,3,4,5,6,7].map(d => (
          <div key={d} style={{
            width: '34px', height: '34px', borderRadius: '50%',
            background: d <= 5 ? 'var(--color-warning)' : 'var(--bg-tertiary)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: d <= 5 ? '16px' : '12px',
            boxShadow: d <= 5 ? '0 0 8px rgba(245,158,11,0.35)' : 'none',
            color: d <= 5 ? '#fff' : 'var(--text-muted)',
            transition: 'all 0.3s'
          }}>
            {d <= 5 ? '🔥' : d}
          </div>
        ))}
      </div>
    )
  },
  { 
    icon: <FiMessageSquare size={22} />, title: 'Aktif Forum',
    desc: 'Çözemediğin soruları sor, kaynak önerileri al ve aynı yoldan geçen adaylarla bilgi alışverişi yap.',
    color: 'var(--color-info)',
  },
  { 
    icon: <FiUsers size={22} />, title: 'Etüt Arkadaşı',
    desc: 'Arkadaşlarınla birlikte çalış, birbirinizi motive edin ve beraber ilerleyin.',
    color: 'var(--accent-secondary)',
  },
];

export default function FeaturesShowcase() {
  return (
    <section className="features-showcase">
      <div className="section-header">
        <motion.p
          className="section-eyebrow"
          initial={{ opacity: 0, y: 15 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          ÖZELLİKLER
        </motion.p>
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Neden <span className="text-gradient">Yelken?</span>
        </motion.h2>
        <motion.p
          className="section-subtitle"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
        >
          Sıradan bir kronometreden çok daha fazlası.
          Seni masada tutacak ve hedefine ulaştıracak ekosistem.
        </motion.p>
      </div>

      {/* Two-column layout: big leaderboard + small feature cards */}
      <div className="features-layout">

        {/* Left: Leaderboard Mock */}
        <motion.div
          className="feature-leaderboard-card glass-card"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="feature-card-header">
            <div className="feature-icon-pill" style={{ background: 'rgba(99,102,241,0.12)', color: 'var(--accent-primary)' }}>
              <FiTrendingUp size={20} />
            </div>
            <h3>Liderlik Tablosu</h3>
          </div>
          <p className="feature-card-desc">
            Her dakika çalışman sana XP kazandırır. Haftalık ve aylık sıralamalarda diğer kaptanlarla yarış!
          </p>

          <div className="mock-leaderboard-table">
            {MOCK_LEADERBOARD.map((item, i) => (
              <div key={i} className={`mock-lb-row ${item.isYou ? 'mock-lb-row--you' : ''}`}>
                <span className="mock-lb-rank">{item.avatar}</span>
                <span className="mock-lb-name">{item.name}</span>
                <span className={`mock-lb-xp ${item.isYou ? 'text-accent' : ''}`}>{item.xp}</span>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Right: Stacked feature cards */}
        <div className="features-stack">
          {/* Daily Tasks Card (bigger) */}
          <motion.div
            className="feature-stack-card glass-card feature-tasks-card"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <div className="feature-card-header">
              <div className="feature-icon-pill" style={{ background: 'rgba(16,185,129,0.12)', color: 'var(--color-success)' }}>
                <FiTarget size={20} />
              </div>
              <h3>Günlük Hedefler</h3>
            </div>
            <p className="feature-card-desc">
              Her gün senin için özel görevler oluşturulur. Tamamla, XP topla, motivasyonunu zirveye taşı.
            </p>
            <div className="mock-tasks-list">
              <div className="mock-task-row mock-task-done">
                <span className="mock-task-check">✓</span>
                <span>30dk Odaklan</span>
                <span className="mock-task-xp">+25 XP</span>
              </div>
              <div className="mock-task-row mock-task-active">
                <span className="mock-task-circle"></span>
                <span>Günün Sözünü Oku</span>
                <span className="mock-task-xp">+10 XP</span>
              </div>
              <div className="mock-task-row">
                <span className="mock-task-circle"></span>
                <span>Forum'da bir cevap yaz</span>
                <span className="mock-task-xp">+15 XP</span>
              </div>
            </div>
          </motion.div>

          {/* Smaller feature cards in a row */}
          <div className="features-mini-grid">
            {FEATURES_RIGHT.map((feat, i) => (
              <motion.div
                key={i}
                className="feature-mini-card glass-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.4 }}
              >
                <div className="feature-icon-pill" style={{ background: `color-mix(in srgb, ${feat.color} 12%, transparent)`, color: feat.color }}>
                  {feat.icon}
                </div>
                <h4>{feat.title}</h4>
                <p className="feature-card-desc">{feat.desc}</p>
                {feat.visual}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
